import { useEffect, useState } from 'react';
import { clearSession, readRefreshToken } from './auth/session';

export function App() {
  const [refreshToken, setRefreshToken] = useState<string | null>(() =>
    readRefreshToken(),
  );

  useEffect(() => {
    const sync = () => {
      setRefreshToken(readRefreshToken());
    };

    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);

  const signedIn = Boolean(refreshToken);

  return (
    <div className="app-shell min-h-screen bg-gray-950 text-gray-50">
      <header className="border-b border-gray-800 px-6 py-4">
        <h1 className="text-xl font-semibold">Link-View</h1>
        <p className="text-sm text-gray-400">User cabinet</p>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-8">
        {signedIn ? (
          <section className="rounded-xl border border-gray-800 bg-gray-900 p-6">
            <h2 className="mb-2 text-lg font-medium">Signed in</h2>
            <p className="mb-4 text-sm text-gray-400">
              Refresh token is shared with the runtime via same-origin storage
              on <code className="text-gray-300">app.linknview.com</code>.
              Access tokens live in runtime memory only.
            </p>
            <dl className="mb-6 space-y-2 text-sm">
              <div>
                <dt className="text-gray-500">Refresh token</dt>
                <dd className="break-all font-mono text-gray-200">
                  {refreshToken}
                </dd>
              </div>
            </dl>
            <button
              type="button"
              className="cursor-pointer rounded-md bg-gray-800 px-4 py-2 text-sm hover:bg-gray-700"
              onClick={() => {
                clearSession();
                setRefreshToken(null);
              }}
            >
              Sign out
            </button>
          </section>
        ) : (
          <section className="rounded-xl border border-dashed border-gray-700 p-6 text-sm text-gray-400">
            <p className="mb-2">You are not signed in.</p>
            <p>
              Use the extension on a streaming site — the login canvas app will
              prompt when authentication is required.
            </p>
          </section>
        )}
      </main>
    </div>
  );
}
